import React, { useEffect, useState } from "react";
import "./styles/sign-in-up.css";
import { useNavigate } from "react-router-dom";

import { CheckCircleTwoTone } from "@ant-design/icons";
import { Popover } from "antd";

import PasswordStrength from "../components/PasswordStrength";
import Axios from "../api/Axios";
import { message, Form, Row, Col, Input, Button } from "antd";
import Footer from "../components/Footer";
import NavBar from "../components/NavBar";
import "./styles/notifications.css";
import {
  InfoCircleOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  EyeTwoTone,
  EyeInvisibleOutlined,
  LoadingOutlined,
  LockOutlined,
} from "@ant-design/icons";
import { useSelector } from "react-redux";
import { commonPasswords } from "../components/icons/ApplicationColor";
import ImagesSlider from "../components/ImagesSlider";
const PasswordResetLogged = () => {
  const userInfo = useSelector((state) => state.user);
  const [form] = Form.useForm();
  const [passwordState, setPasswordState] = useState("");
  const [loading, setLoading] = useState(false);
  const [successReset, setSuccessReset] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [passName, setPassName] = useState("");
  const [passUID, setPassUID] = useState("");
  const [passCID, setPassCID] = useState("");

  // const verificationStatus = useSelector(
  //   (state) => state.verification.verificationStatus
  // );
  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    setPasswordState(newPassword);
    // form.setFieldsValue({ password: newPassword }); // Update form field value
  };
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");

  const WrongPassword = (text) => {
    const textDis =
      text === "Wrong Password" ? "Entered old password is wrong" : text;
    messageApi.open({
      type: "error",
      content: textDis,
      duration: 7,
    });
  };
  // const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
  //   useFormik({
  //     initialValues: initialValues,
  //     validationSchema: resetPasswordSchema2,
  //     onSubmit: (values) => {
  //       handleFormSubmit(values);
  //       console.log("logiing formik", values);
  //     },
  //   });
  const history = useNavigate();

  const navigate = () => {
    history("/home");
  };

  const handleFormSubmit = async (values) => {
    try {
      await Axios.post(
        `/passwordreset/`,
        {
          new_password: values.password,
          old_password: values.oldPassword,
        },
        {
          headers: {
            "X-CSRFToken": csrfToken,
          },
        }
      );
      //console.log(res);
      setSuccessReset(true);
      setLoading(false);
    } catch (err) {
      WrongPassword(err?.response?.data?.detail);
      setLoading(false);
      //console.log(err);
    }
  };

  const getPasswordRequirements = () => {
    const hasCapitalLetter = passwordState?.match(/[A-Z]/);
    const hasSmallLetter = passwordState?.match(/[a-z]/);
    const hasSpecialCharacter = passwordState?.match(/[_\W]/);

    const hasNumericCharacter = passwordState?.match(/[0-9]/);

    return [
      {
        text: "At least 1 capital and small letter",
        icon:
          hasCapitalLetter && hasSmallLetter ? (
            <CheckCircleOutlined
              style={{ color: "green", marginRight: "0.3rem" }}
            />
          ) : (
            <CloseCircleOutlined
              style={{ color: "red", marginRight: "0.3rem" }}
            />
          ),
      },
      {
        text: "At least 1 special and numeric character",
        icon:
          hasSpecialCharacter && hasNumericCharacter ? (
            <CheckCircleOutlined
              style={{ color: "green", marginRight: "0.3rem" }}
            />
          ) : (
            <CloseCircleOutlined
              style={{ color: "red", marginRight: "0.3rem" }}
            />
          ),
      },
      {
        text: "Minimum 8 characters",
        icon:
          passwordState.length >= 8 ? (
            <CheckCircleOutlined
              style={{ color: "green", marginRight: "0.3rem" }}
            />
          ) : (
            <CloseCircleOutlined
              style={{ color: "red", marginRight: "0.3rem" }}
            />
          ),
      },
    ];
  };

  const content = (
    <ul
      className="password-requirements"
      style={{ paddingLeft: "0.5rem", listStyleType: "none" }}
    >
      {getPasswordRequirements().map((requirement, index) => (
        <li key={index} style={{ padding: "0.3rem" }}>
          {requirement.icon} {requirement.text}
        </li>
      ))}
    </ul>
  );

  const [passwordSuccess, setPasswordSuccess] = useState(false);
  const [showInfo, setShowInfo] = useState(false);
  // useEffect(() => {
  //   const passwordErrors = form.getFieldError("password");
  //   console.log("Password Errors:", passwordErrors);
  //   console.log(passwordState, form.getFieldError("password"));
  //   if (passwordState === "") {
  //     setPasswordSuccess(false);
  //   } else if (form.getFieldError("password")) {
  //     setPasswordSuccess(false);
  //   } else {
  //     setPasswordSuccess(true);
  //   }
  // }, [passwordState, form]);
  useEffect(() => {
    const validatePassword = async () => {
      try {
        await form.validateFields(["password"]);
        setPasswordSuccess(true);
        setShowInfo(false);
      } catch (errorInfo) {
        //console.log("Password Validation Error:", errorInfo.errorFields);
        setPasswordSuccess(false);
      }
    };
    if (passwordState.length > 0) {
      validatePassword();
    }
  }, [form, passwordState]);
  const handleConfirmPasswordPaste = (e) => {
    e.preventDefault();
  };
  const checkPassword = async () => {
    try {
      const res = await Axios.get(`/passwordrules/`);
      //console.log(res.data.detail);
      setPassName(res.data.detail.first_name);
      setPassUID(res.data.detail.user_id);
      setPassCID(res.data.detail.client_id);
    } catch (err) {
      //console.log(err);
    }
  };
  useEffect(() => {
    checkPassword();
  }, []);
  return (
    <div className="main-body">
      {contextHolder}
      <header>
        <NavBar data={userInfo} />
      </header>
      <div className="main-co" style={{ height: "87.5vh" }}>
        <div className="cont" style={{ height: "56rem" }}>
          <div className="left">
            <div
              className="signIn_text1"
              style={{ width: "400px", paddingTop: "40px" }}
            >
              Change Password
            </div>

            {successReset ? (
              <>
                <div className="verified-user">
                  Password is successfully Changed &nbsp;
                  <CheckCircleTwoTone twoToneColor="#52c41a" />
                  <div style={{ marginTop: "1rem" }}>
                    To go to home page{" "}
                    <span
                      style={{ color: " #295BDC", cursor: "pointer" }}
                      onClick={navigate}
                    >
                      Click here
                    </span>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="text-para1">
                  Refer the Password Strength meter and set a secure password
                </div>
                <Form
                  form={form}
                  initialValues={{
                    oldPassword: "",
                    password: "",
                    confirmPassword: "",
                  }}
                  onFinish={(values) => {
                    if (!loading) {
                      form
                        .validateFields()
                        .then(() => {
                          setLoading(true);
                          handleFormSubmit(values);
                        })
                        .catch((errorInfo) => {
                          //console.log("Form validation failed:", errorInfo);
                        });
                    }
                  }}
                >
                  {/* <div className="pass-con">
                    <div className="password-box">
                      <input
                        placeholder="Old password"
                        className="input-col21"
                        type={hidePassword3 ? "text" : "password"}
                        name="oldPassword"
                        onChange={handleChange}
                        value={values.oldPassword}
                        onBlur={handleBlur}
                      />
                      <img
                        className="eye-logo"
                        src={hidePassword3 ? Eye : EyeOff}
                        alt=""
                        onClick={togglePasswordVisiblity3}
                      />
                    </div>
                  </div> */}
                  <Row gutter={10} style={{ paddingTop: "20px" }}>
                    <Col xs={20} sm={20} md={21} lg={21} xl={21}>
                      <Form.Item
                        name="oldPassword"
                        rules={[
                          {
                            required: true,
                            message: "Old Password is required",
                          },
                          {
                            min: 4,
                            message: "Password must be at least 4 characters",
                          },
                        ]}
                      >
                        <Input.Password
                          placeholder="Old Password"
                          className="input-col1"
                          type="Password"
                          name="oldPassword"
                          id="oldPassword"
                          onPaste={handleConfirmPasswordPaste}
                          iconRender={(visible) =>
                            visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                          }
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row gutter={10}>
                    <Col xs={20} sm={20} md={21} lg={21} xl={21}>
                      <Form.Item
                        name="password"
                        rules={[
                          {
                            validator: (_, value) => {
                              if (!value) {
                                return Promise.reject("Password is required");
                              }
                              if (value.includes(" ")) {
                                return Promise.reject("Spaces are not allowed");
                              }
                              if (value.length < 8) {
                                return Promise.reject(
                                  "Password must be at least 8 characters"
                                );
                              }
                              if (
                                commonPasswords.some((common) =>
                                  value
                                    .toLowerCase()
                                    .includes(common.toLowerCase())
                                )
                              ) {
                                return Promise.reject(
                                  "Commonly used passwords are not allowed"
                                );
                              }
                              if (
                                !/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[_\W])[A-Za-z\d_\W]{8,}$/.test(
                                  value
                                )
                              ) {
                                setShowInfo(true);
                                return Promise.reject(
                                  "Password should meet the criteria"
                                );
                              }
                              const lowercaseValue = value.toLowerCase();
                              const lowercaseName = passName.toLowerCase();
                              const lowercaseUID = passUID.toLowerCase();
                              const lowercaseCID = passCID.toLowerCase();

                              if (
                                lowercaseValue.includes(lowercaseName) &&
                                passName !== ""
                              ) {
                                return Promise.reject(
                                  "Password should not contain your First Name"
                                );
                              }
                              if (
                                lowercaseValue.includes(lowercaseUID) &&
                                passUID !== ""
                              ) {
                                return Promise.reject(
                                  "Password should not contain your User ID"
                                );
                              }
                              if (
                                lowercaseValue.includes(lowercaseCID) &&
                                passCID !== ""
                              ) {
                                return Promise.reject(
                                  "Password should not contain your Client ID"
                                );
                              }

                              return Promise.resolve();
                            },
                          },
                        ]}
                      >
                        <Input.Password
                          placeholder="Password"
                          className="input-col1"
                          type="password"
                          onPaste={handleConfirmPasswordPaste}
                          onChange={handlePasswordChange}
                          iconRender={(visible) =>
                            visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                          }
                        />
                      </Form.Item>
                    </Col>
                    <Col span={2}>
                      {passwordSuccess ? (
                        <Popover content={content}>
                          <CheckCircleOutlined
                            style={{
                              marginLeft: "5px",
                              paddingTop: "15px",
                              color: "green",
                              fontSize: "2.1rem",
                              verticalAlign: "middle",
                              cursor: "pointer",
                            }}
                          />
                        </Popover>
                      ) : !passwordSuccess && passwordState.length !== 0 ? (
                        <Popover content={content} open={showInfo}>
                          <InfoCircleOutlined
                            style={{
                              color: "red",
                              fontSize: "2.1rem",
                              marginLeft: "5px",
                              paddingTop: "15px",
                              verticalAlign: "middle",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setShowInfo((prev) => !prev);
                            }}
                          />
                        </Popover>
                      ) : (
                        <Popover content={content}>
                          <InfoCircleOutlined
                            style={{
                              color: "orange",
                              fontSize: "2.1rem",
                              marginLeft: "5px",
                              paddingTop: "15px",
                              verticalAlign: "middle",
                              cursor: "pointer",
                            }}
                          />
                        </Popover>
                      )}
                    </Col>
                  </Row>

                  <Row gutter={5}>
                    <Col xs={20} sm={20} md={21} lg={21} xl={21}>
                      <div className="strength-container">
                        <PasswordStrength password={passwordState} />
                      </div>
                    </Col>
                  </Row>
                  {/* <div className="pass-con">
                    <div className="password-box">
                      <input
                        placeholder="Confirm password"
                        className="input-col21"
                        type={hidePassword2 ? "text" : "password"}
                        name="confirmPassword"
                        onChange={handleChange}
                        value={values.confirmPassword}
                        onBlur={handleBlur}
                        onPaste={(e) => e.preventDefault()} // Prevent pasting
                        autoComplete="off" // You can set autoComplete to "off" if desired
                      />
                      <img
                        className="eye-logo"
                        src={hidePassword2 ? Eye : EyeOff}
                        alt=""
                        onClick={togglePasswordVisiblity2}
                      />
                    </div>
                  </div> */}
                  <Row gutter={10} style={{ paddingTop: "25px" }}>
                    <Col xs={20} sm={20} md={21} lg={21} xl={21}>
                      <Form.Item
                        name="confirmPassword"
                        rules={[
                          {
                            required: true,
                            message: "Confirm Password is required",
                          },
                          ({ getFieldValue }) => ({
                            validator(_, value) {
                              const password = getFieldValue("password");
                              if (!value || password === value) {
                                return Promise.resolve();
                              }
                              return Promise.reject("Passwords do not match");
                            },
                          }),
                        ]}
                      >
                        <Input.Password
                          placeholder="Confirm Password"
                          className="input-col1"
                          type="password"
                          name="confirmPassword"
                          id="confirmPassword"
                          onPaste={handleConfirmPasswordPaste}
                          iconRender={(visible) =>
                            visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                          }
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row gutter={20}>
                    <Col xs={20} sm={20} md={21} lg={21} xl={21}>
                      <Form.Item>
                        <Button
                          className="button-29"
                          type="primary"
                          htmlType="submit"
                          style={{
                            marginTop: "0.5rem",
                            cursor: loading ? "not-allowed" : "pointer",
                          }}
                          disabled={loading}
                        >
                          CHANGE PASSWORD
                          {loading ? (
                            <LoadingOutlined />
                          ) : (
                            <LockOutlined style={{ fontSize: "17px" }} />
                          )}
                        </Button>
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
              </>
            )}
          </div>
          <ImagesSlider />
        </div>
      </div>
      <footer>
        <Footer />
      </footer>
    </div>
  );
};

export default PasswordResetLogged;
